import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "all-movies-area pb-100" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "all-movies-inner" }
const _hoisted_4 = { class: "all-movies-card" }
const _hoisted_5 = { class: "image" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lightgallery = _resolveComponent("lightgallery")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mh-movies-title" }, [
        _createElementVNode("h5", { class: "text-white" }, "أحدث الأفلام والمسلسلات الحصرية")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Swiper, {
          spaceBetween: 25,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            prevEl: '.movies-button-prev',
            nextEl: '.movies-button-next',
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
            1600: {
              slidesPerView: 5,
            },
          },
          modules: _ctx.modules,
          class: "all-movies-slider"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movies, (movie, index) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        src: movie.image,
                        alt: movie.title
                      }, null, 8, _hoisted_6),
                      _createVNode(_component_lightgallery, {
                        settings: { speed: 500, plugins: _ctx.plugins }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: movie.trailer,
                            class: "video-btn"
                          }, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("i", { class: "ri-play-fill" }, null, -1)
                          ]))], 8, _hoisted_7)
                        ]),
                        _: 2
                      }, 1032, ["settings"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "top" }, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "link-btn"
                        }, [
                          _createTextVNode(" إضافة للمفضلة "),
                          _createElementVNode("i", { class: "ri-add-line" })
                        ]),
                        _createElementVNode("div", { class: "share" }, [
                          _createElementVNode("i", { class: "ri-share-fill" }),
                          _createElementVNode("ul", { class: "list" }, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: "https://www.facebook.com/",
                                target: "_blank"
                              }, [
                                _createElementVNode("i", { class: "ri-facebook-fill" })
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: "https://x.com/",
                                target: "_blank"
                              }, [
                                _createElementVNode("i", { class: "ri-twitter-x-line" })
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                href: "https://www.instagram.com/",
                                target: "_blank"
                              }, [
                                _createElementVNode("i", { class: "ri-instagram-fill" })
                              ])
                            ])
                          ])
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h3", null, _toDisplayString(movie.title), 1),
                        _createElementVNode("span", null, "الجودة: " + _toDisplayString(movie.time), 1)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules"]),
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"all-movies-button\"><div class=\"movies-button-prev\"><i class=\"ri-arrow-left-s-line\"></i></div><div class=\"movies-button-next\"><i class=\"ri-arrow-right-s-line\"></i></div></div>", 1))
      ])
    ])
  ]))
}